import { useCallback, useEffect, useRef, useState } from 'react';
import { useAppSelector } from 'hooks';
import { selectCurrentTeam } from 'containers/app/appSlice';
import { useLazyGetPayRunsQuery } from '../api';
import DateUtils from 'utils/dateUtils';
import { PayRunListItem } from '../payrun.model';
export const initialQueryParamsState = {
  status: [],
  payPeriodFrom: null,
  payPeriodTo: null,
  page: 1,
  limit: 50
};

export const usePaginatedGetPayRunsQuery = (
  status: string[],
  payPeriodFrom: string | null,
  payPeriodTo: string | null
) => {
  const currentTeam = useAppSelector(selectCurrentTeam);
  const [list, setList] = useState<PayRunListItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [totalListCount, setTotalListCount] = useState(0);
  const page = useRef(1);

  const [getPayRunsData, { data: payRunsData, isFetching }] = useLazyGetPayRunsQuery();

  useEffect(() => {
    if (payRunsData) {
      setList(payRunsData.payRuns);
      setTotalListCount(payRunsData.totalCount);
      setHasMore(payRunsData.currentCount < payRunsData.totalCount);
    }
  }, [payRunsData, isFetching]);

  useEffect(() => {
    if (!isFetching) {
      setIsLoading(false);
    }
  }, [isFetching]);

  const loadMore = useCallback(
    (currentPage: number) => {
      if (currentTeam?.id) {
        page.current = currentPage;
        setIsLoading(true);
        getPayRunsData({
          teamId: currentTeam.id,
          status: status.length > 0 ? status : null,
          payPeriodFrom: DateUtils.startDateToUTCString(payPeriodFrom) || null,
          payPeriodTo: DateUtils.endDateToUTCString(payPeriodTo) || null,
          page: page.current - 1,
          limit: 50
        });
      }
    },
    [currentTeam?.id, status, payPeriodFrom, payPeriodTo, getPayRunsData]
  );

  useEffect(() => {
    if (currentTeam?.id) {
      page.current = 1;
      setList([]);
      loadMore(page.current);
    }
  }, [currentTeam?.id, status, payPeriodFrom, payPeriodTo]);

  return {
    list,
    page: page.current,
    isLoading,
    loadMore,
    totalListCount,
    hasMore
  };
};
